<template>
  <section>
    <div class="grid grid-cols-12 gap-6">
      <div class="col-span-12 xxl:col-span-9 grid grid-cols-12 gap-6">

          <!-- General Report -->
          <div class="col-span-12 mt-8">
              <div class="intro-y flex items-center h-10">
                  <h2 class="text-lg font-medium truncate mr-5">
                    Reporte General
                  </h2>
              </div>
              <div class="grid grid-cols-12 gap-6 mt-5">
                  <div class="col-span-12 sm:col-span-6 xl:col-span-3 intro-y">
                      <div class="report-box zoom-in">
                          <div class="box p-5" @click="$router.push('traffic/tasks')">
                              <div class="flex">
                                  <app-icon name="file-plus" classname="report-box__icon text-theme-10"></app-icon>
                              </div>
                              <div class="text-3xl font-bold leading-8 mt-6">{{tasks.length}}</div>
                              <div class="text-base text-gray-600 mt-1">Tareas</div>
                          </div>
                      </div>
                  </div>
                  <div class="col-span-12 sm:col-span-6 xl:col-span-3 intro-y">
                      <div class="report-box zoom-in">
                          <div class="box p-5" @click="$router.push('traffic/campaigns')">
                              <div class="flex">
                                  <app-icon name="file" classname="report-box__icon text-theme-11"></app-icon>
                              </div>
                              <div class="text-3xl font-bold leading-8 mt-6">{{campaigns.length}}</div>
                              <div class="text-base text-gray-600 mt-1">Campañas</div>
                          </div>
                      </div>
                  </div>
                  <div class="col-span-12 sm:col-span-6 xl:col-span-3 intro-y">
                      <div class="report-box zoom-in">
                          <div class="box p-5" @click="$router.push('traffic/accounts')">
                              <div class="flex">
                                  <app-icon name="folder" classname="report-box__icon text-theme-12"></app-icon>
                              </div>
                              <div class="text-3xl font-bold leading-8 mt-6">{{accounts.length}}</div>
                              <div class="text-base text-gray-600 mt-1">Cuentas</div>
                          </div>
                      </div>
                  </div>
                  <div class="col-span-12 sm:col-span-6 xl:col-span-3 intro-y">
                      <div class="report-box zoom-in">
                          <div class="box p-5" @click="$router.push('users')">
                              <div class="flex">
                                  <app-icon name="user" classname="report-box__icon text-theme-9"></app-icon>
                              </div>
                              <div class="text-3xl font-bold leading-8 mt-6">{{users.length}}</div>
                              <div class="text-base text-gray-600 mt-1">Usuarios</div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <!-- END: General Report -->

      </div>
    </div>

  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Icon from '@/components/admin/partials/Icon'

export default {
  name: 'DashboardAdmin',
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      users: 'getUsers',
      accounts: 'getAccounts',
      campaigns: 'getCampaigns',
      tasks: 'getTasks'
    }),

  },
  async beforeMount () {
    try {
      this.getList('campaign')
      this.getList('account')
      await this.getListTasksMongo('task')
      this.loading = true
    } catch (error) {}
  },
  methods: {
    ...mapActions([
      'getListTasksMongo'
      ])
  },
  components: {
    appIcon: Icon
  },

}
</script>



// WEBPACK FOOTER //
// Dashboard.vue?77aa1d18